// src/components/Projects.js
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { projects } from '../data/projects';
import ProjectCard from './ProjectCard';

const Projects = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        minHeight: '100vh',
        p: { xs: 2, sm: 4 },
        backdropFilter: 'blur(5px)',
        overflowX: 'hidden', // Prevent horizontal scroll
      }}
    >
      <Typography variant="h3" color="primary" gutterBottom>
        Our Excavation Projects
      </Typography>
      <Grid container spacing={3} alignItems="stretch">
        {projects.map((project) => (
          <Grid
            key={project.id}
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
            }}
          >
            <ProjectCard project={project} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Projects;
